/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Arrow-right': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M1.242 6.774H11.76L7.652 2.655a1.294 1.294 0 010-1.79 1.24 1.24 0 011.756 0l6.244 6.277c.464.469.464 1.306 0 1.775l-6.244 6.278a1.24 1.24 0 01-1.756 0 1.326 1.326 0 01-.364-.888c0-.318.132-.652.364-.887l4.108-4.135H1.242A1.237 1.237 0 010 8.029c0-.686.547-1.255 1.242-1.255z" _fill="#fff"/>'
  }
})
